import request from '@/utils/request'

export default {
  login: function (data) {
    return request({
      url: '/user/login',
      method: 'post',
      data: data
    })
  },
  logout: function (data) {
    return request({
      url: '/user/logout',
      method: 'post',
      data: data
    })
  },
  getUserInfoByMobile: function (data) {
    return request({
      url: '/user/getUserInfoByMobile',
      method: 'get',
      params: data
    })
  },
  compareToken: function (data) {
    return request({
      url: '/user/compareToken',
      method: 'get',
      params: data
    })
  },
  getAllUserInfo: function () {
    return request({
      url: '/user/getAllUserInfo',
      method: 'get'
    })
  },
  addGroup: function (data) {
    return request({
      url: '/user/addGroup',
      method: 'POST',
      data: data
    })
  },
  sendMessage: function (data) {
    return request({
      url: '/lk/sendMessage',
      method: 'post',
      data: data
    })
  },
  getAllMessage: function (data) {
    return request({
      url: '/lk/getAllMessage',
      method: 'get',
      params: data
    })
  },
  getMenu: function (data) {
    return request({
      url: '/lk/getMenu',
      method: 'get',
      params: data
    })
  },
  // add lk  2020.6.3 start
  getProjectById: function (data) {
    return request({
      url: '/lk/getProjectById',
      method: 'get',
      params: data
    })
  },
  // add lk 2020.6.3 end
  getGroup: function (data) {
    return request({
      url: '/user/getGroup',
      method: 'get',
      params: data
    })
  },
  // blast start
  getBlast: function (data) {
    return request({
      url: '/blast/getBlast',
      method: 'get',
      params: data
    })
  },
  addBlast: function (data) {
    return request({
      url: '/blast/addBlast',
      method: 'POST',
      data: data
    })
  },
  updateBlast: function (data) {
    return request({
      url: '/blast/updateBlast',
      method: 'POST',
      data: data
    })
  },
  deleteBlast: function (data) {
    return request({
      url: '/blast/deleteBlast',
      method: 'POST',
      data: data
    })
  },
  deleteBlastDetail: function (data) {
    return request({
      url: '/blast/deleteBlastDetail',
      method: 'POST',
      data: data
    })
  },
  getBlastDetail: function (data) {
    return request({
      url: '/blast/getBlastDetail',
      method: 'GET',
      params: data
    })
  },
  genWord: function (data) {
    return request({
      url: '/blast/genWord',
      method: 'POST',
      params: data,
      responseType: 'blob'
    })
  },
  // blast end
  // sys start
  getRoleInfo: function (data) {
    return request({
      url: '/sys/getRoleInfo',
      method: 'GET',
      params: data
    })
  },
  getMenuTree: function (data) {
    return request({
      url: '/sys/getMenuTree',
      method: 'GET',
      params: data
    })
  },
  addOrUpdateRole: function (data) {
    return request({
      url: '/sys/addOrUpdateRole',
      method: 'POST',
      data: data
    })
  },
  deleteRole: function (data) {
    return request({
      url: '/sys/deleteRole',
      method: 'POST',
      data: data
    })
  },
  getUser: function (data) {
    return request({
      url: '/sys/getUser',
      method: 'GET',
      params: data
    })
  },
  addOrUpdateUser: function (data) {
    return request({
      url: '/sys/addOrUpdateUser',
      method: 'POST',
      data: data
    })
  },
  deleteUser: function (data) {
    return request({
      url: '/sys/deleteUser',
      method: 'POST',
      data: data
    })
  },
  getAllApi: function () {
    return request({
      url: '/sys/getAllApi',
      method: 'GET'
    })
  },
  getAllRole: function () {
    return request({
      url: '/sys/getAllRole',
      method: 'GET'
    })
  },
  addOrUpdateApi: function (data) {
    return request({
      url: '/sys/addOrUpdateApi',
      method: 'POST',
      data: data
    })
  },

  deleteApi: function (data) {
    return request({
      url: '/sys/deleteApi',
      method: 'POST',
      params: data
    })
  },
  // sys end
  // progress start
  getGant: function (data) {
    return request({
      url: '/progress/getGant',
      method: 'GET',
      params: data
    })
  },
  updateGantTask: function (data) {
    return request({
      url: '/progress/updateGantTask',
      method: 'POST',
      data: data
    })
  },
  addGantLink: function (data) {
    return request({
      url: '/progress/addGantLink',
      method: 'POST',
      data: data
    })
  },
  deleteGantLink: function (data) {
    return request({
      url: '/progress/deleteGantLink',
      method: 'POST',
      data: data
    })
  },
  getProgressProject: function (data) {
    return request({
      url: '/progress/getProgressProject',
      method: 'GET',
      params: data
    })
  },
  updateProgressProject: function (data) {
    return request({
      url: '/progress/updateProgressProject',
      method: 'POST',
      data: data
    })
  },
  getQualityById: function (data) {
    return request({
      url: '/progress/getQualityById',
      method: 'GET',
      params: data
    })
  },
  addProgress: function (data) {
    return request({
      url: '/progress/addProgress',
      method: 'POST',
      data: data
    })
  },
  deleteProgress: function (data) {
    return request({
      url: '/progress/deleteProgress',
      method: 'POST',
      params: data
    })
  },
  getProgressRecordByProgressId: function (data) {
    return request({
      url: '/progress/getProgressRecordByProgressId',
      method: 'GET',
      params: data
    })
  },
  addProgressRecord: function (data) {
    return request({
      url: '/progress/addProgressRecord',
      method: 'POST',
      data: data
    })
  },
  getChartData: function (data) {
    return request({
      url: '/progress/getChartData',
      method: 'GET',
      params: data
    })
  },
  updateRecord: function (data) {
    return request({
      url: '/progress/updateRecord',
      method: 'POST',
      data: data
    })
  },
  deleteRecord: function (data) {
    return request({
      url: '/progress/deleteRecord',
      method: 'POST',
      params: data
    })
  },
  // progress end
  // led start
  getLEDData: function (data) {
    return request({
      url: '/led/getLEDData',
      method: 'GET',
      params: data
    })
  },
  // led end
  // source start
  getSourceTypeListPage: function (data) {
    return request({
      url: '/source/getSourceTypeListPage',
      method: 'GET',
      params: data
    })
  },
  addSourceType: function (data) {
    return request({
      url: '/source/addSourceType',
      method: 'POST',
      data: data
    })
  },
  editSourceType: function (data) {
    return request({
      url: '/source/editSourceType',
      method: 'POST',
      data: data
    })
  },
  deleteSourceType: function (data) {
    return request({
      url: '/source/deleteSourceType',
      method: 'POST',
      params: data
    })
  },
  getSource: function (data) {
    return request({
      url: '/source/getSource',
      method: 'GET',
      params: data
    })
  },
  addSource: function (data) {
    return request({
      url: '/source/addSource',
      method: 'POST',
      data: data
    })
  },
  updateSource: function (data) {
    return request({
      url: '/source/updateSource',
      method: 'POST',
      data: data
    })
  },
  deleteSource: function (data) {
    return request({
      url: '/source/deleteSource',
      method: 'POST',
      params: data
    })
  },
  // add lk 2020.6.8 start
  addSourceRecord: function (data) {
    return request({
      url: '/source/addSourceRecord',
      method: 'POST',
      data: data
    })
  },
  getSourceRecordById: function (data) {
    return request({
      url: '/source/getSourceRecordById',
      method: 'GET',
      params: data
    })
  },
  // add lk 2020.6.8 end
  addSourceUser: function (data) {
    return request({
      url: '/source/addSourceUser',
      method: 'POST',
      data: data
    })
  },
  updateSourceUser: function (data) {
    return request({
      url: '/source/updateSourceUser',
      method: 'POST',
      data: data
    })
  },
  deleteSourceUser: function (data) {
    return request({
      url: '/source/deleteSourceUser',
      method: 'POST',
      params: data
    })
  },
  getSourceUser: function (data) {
    return request({
      url: '/source/getSourceUser',
      method: 'GET',
      params: data
    })
  },
  getSourceShow: function (data) {
    return request({
      url: '/source/getSourceShow',
      method: 'GET',
      params: data
    })
  },
  getImg: function (data) {
    return request({
      url: '/source/getImg',
      method: 'POST',
      responseType: 'blob',
      params: data
    })
  },
  // add by zf 2020 start
  getImg1: function (data) {
    return request({
      url: '/source/getImg1',
      method: 'POST',
      responseType: 'blob',
      params: data
    })
  },

  // add by zf 2020 end

  getUserNowDayAttendance: function (data) {
    return request({
      url: '/source/getUserNowDayAttendance',
      method: 'GET',
      params: data
    })
  },
  addAttendance: function (data) {
    return request({
      url: '/source/addAttendance',
      method: 'POST',
      data: data
    })
  },
  addWorkTime: function (data) {
    return request({
      url: '/source/addWorkTime',
      method: 'POST',
      data: data
    })
  },
  getWorkTime: function () {
    return request({
      url: '/source/getWorkTime',
      method: 'GET'
    })
  },
  getAttendanceBySourceUserId: function (data) {
    return request({
      url: '/source/getAttendanceBySourceUserId',
      method: 'GET',
      params: data
    })
  },
  getWorkType: function () {
    return request({
      url: '/source/getWorkType',
      method: 'GET'
    })
  },
  addWorkType: function (data) {
    return request({
      url: '/source/addWorkType',
      method: 'POST',
      data: data
    })
  },
  updateWorkType: function (data) {
    return request({
      url: '/source/updateWorkType',
      method: 'POST',
      data: data
    })
  },
  deleteWorkType: function (data) {
    return request({
      url: '/source/deleteWorkType',
      method: 'POST',
      params: data
    })
  },
  // source end

  // metering start
  getMeteringGroupProject: function (data) {
    return request({
      url: '/metering/getMeteringGroupProject',
      method: 'GET',
      params: data
    })
  },

  addMeteringGroupProject: function (data) {
    return request({
      url: '/metering/addMeteringGroupProject',
      method: 'POST',
      data: data
    })
  },
  updateMeteringGroupProject: function (data) {
    return request({
      url: '/metering/updateMeteringGroupProject',
      method: 'POST',
      data: data
    })
  },
  deleteMeteringGroupProject: function (data) {
    return request({
      url: '/metering/deleteMeteringGroupProject',
      method: 'POST',
      params: data
    })
  },
  deleteMeteringList: function (data) {
    return request({
      url: '/metering/deleteMeteringList',
      method: 'POST',
      params: data
    })
  },
  getMeteringGroupList: function (data) {
    return request({
      url: '/metering/getMeteringGroupList',
      method: 'GET',
      params: data
    })
  },
  addMeteringGroupList: function (data) {
    return request({
      url: '/metering/addMeteringGroupList',
      method: 'POST',
      data: data
    })
  },
  updateMeteringGroupList: function (data) {
    return request({
      url: '/metering/updateMeteringGroupList',
      method: 'POST',
      data: data
    })
  },
  change: function (data) {
    return request({
      url: '/metering/change',
      method: 'POST',
      data: data
    })
  },
  getRecord: function (data) {
    return request({
      url: '/metering/getRecord',
      method: 'GET',
      params: data
    })
  },
  addMeteringVisa: function (data) {
    return request({
      url: '/metering/addMeteringVisa',
      method: 'POST',
      data: data
    })
  },
  getVisaUserInfo: function (data) {
    return request({
      url: '/metering/getVisaUserInfo',
      method: 'GET',
      params: data
    })
  },
  getMyVisa: function (data) {
    return request({
      url: '/metering/getMyVisa',
      method: 'GET',
      params: data
    })
  },
  getMyHandle: function (data) {
    return request({
      url: '/metering/getMyHandle',
      method: 'GET',
      params: data
    })
  },
  updateMeteringVisaDeal: function (data) {
    return request({
      url: '/metering/updateMeteringVisaDeal',
      method: 'POST',
      data: data
    })
  },
  getZongHeData: function (data) {
    return request({
      url: '/metering/getZongHeData',
      method: 'GET',
      params: data
    })
  },
  // metering end
  getIframeUrl: function (data) {
    return request({
      url: '/lk/getIframeUrl',
      method: 'GET'
    })
  },
  upFile: function (data) {
    return request({
      url: '/blast/solveFile',
      method: 'POST',
      data: data,
      headers: { // 修改请求头
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/lk.js